// extracted by mini-css-extract-plugin
export default {"container":"footer-list-module--container--VnBhg","list":"footer-list-module--list--w-wzW","title":"footer-list-module--title--k-rry","link":"footer-list-module--link--8jTe0"};